import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1d69c0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "prevent-hover-overlay",
  "data-heap": "product-tour-bullet-points"
}, null, -1))

import {number} from 'vue-types';
    import {useOnboardingExistingUser} from '..';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TourCardIndicators',
  props: {
        tourIndex: number().isRequired,
    },
  setup(__props) {

const props = __props;

    

    const onboardingExistingUserStore = useOnboardingExistingUser();

return (_ctx: any,_cache: any) => {
  const _component_joy_indicator = _resolveComponent("joy-indicator")!
  const _component_joy_product_tour_trigger = _resolveComponent("joy-product-tour-trigger")!
  const _component_joy_indicators = _resolveComponent("joy-indicators")!

  return (_openBlock(), _createBlock(_component_joy_indicators, null, {
    default: _withCtx(() => [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(onboardingExistingUserStore).activeTours, (tour, bulletIndex) => {
        return (_openBlock(), _createBlock(_component_joy_product_tour_trigger, {
          key: tour.navTabId
        }, {
          default: _withCtx(() => [
            _createVNode(_component_joy_indicator, {
              selected: _unref(onboardingExistingUserStore).selectedOnboardingTourStepIndex === bulletIndex
            }, null, 8, ["selected"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }))
}
}

})